import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import CheckInDatesList from '../components/admin/check-in-dates-list';
import DangerZone from '../components/admin/danger-zone';
import ManageCustomFields from '../components/admin/manage-custom-fields';
import ManageEvents from '../components/admin/manage-events';
import ManagePrinters from '../components/admin/manage-printers';
import UsersList from '../components/admin/users-list';

const AdminPage = () => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
          gap: 2,
        }}
      >
        <Typography variant='h5'>Admin</Typography>
      </Box>

      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls='events-content'
          id='events-header'
        >
          <Typography variant='h6'>Events</Typography>
        </AccordionSummary>
        <AccordionDetails id='events-content'>
          <ManageEvents />
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls='check-in-dates-content'
          id='check-in-dates-header'
        >
          <Typography variant='h6'>Check-in dates</Typography>
        </AccordionSummary>
        <AccordionDetails id='check-in-dates-content'>
          <CheckInDatesList />
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls='printers-content'
          id='printers-header'
        >
          <Typography variant='h6'>Printers</Typography>
        </AccordionSummary>
        <AccordionDetails id='printers-content'>
          <ManagePrinters />
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls='custom-fields-content'
          id='custom-fields-header'
        >
          <Typography variant='h6'>Custom fields</Typography>
        </AccordionSummary>
        <AccordionDetails id='custom-fields-content'>
          <ManageCustomFields />
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls='users-content'
          id='users-header'
        >
          <Typography variant='h6'>Users</Typography>
        </AccordionSummary>
        <AccordionDetails id='users-content'>
          <UsersList />
        </AccordionDetails>
      </Accordion>

      {/*
        Danger zone is collapsed by default so its destructive actions stay
        out of muscle-memory reach. The red title styling makes the section
        unmistakable when expanded.
      */}
      <Accordion sx={{ mt: 2, borderColor: 'error.main' }}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls='danger-zone-content'
          id='danger-zone-header'
        >
          <Typography variant='h6' color='error'>
            Danger zone
          </Typography>
        </AccordionSummary>
        <AccordionDetails id='danger-zone-content'>
          <DangerZone />
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default AdminPage;
